import { Component, ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import {
  CRM,
  CRMCampaign,
  CRMTypeId,
  FunnelFulfillmentType,
  ImageSize,
  Pager,
  Region,
  AudienceConditionType,
  AudienceBillingCycle,
  getCampaignProductImageUrl,
  BillingCycleNoMax,
  AudienceFilterDescriptions,
  ProductSortOption,
  ProductSortOptionLabels,
  AudiencePopup,
  CampaignProduct,
  Audience,
  AudienceBillingCycleOptions,
  AudienceCardTypeOptions,
  AudiencePaymentTypeOptions,
  AudienceTrafficSourceOptions,
  AudienceItemStatusOptions,
  SingleStepPathFilter,
  DefaultMinBillingCycle,
  SurveyResponseCategory,
  EmptyBillingCycleValue,
  OfferIntents,
  AudienceDropdownSettings,
  AudienceProductBatchSize,
  getCRMCampaignLabel,
  splitAudienceIds,
} from '../../../_models';
import {
  AlertService,
  AudienceService,
  CampaignProductService,
  CancelReasonCategoryService,
  CRMCampaignService,
  CRMService,
  LoaderService,
  RegionService,
  SingleStepFilterService,
  StorageService,
} from '../../../_services';
import { FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { takeUntil } from 'rxjs/operators';
import { config } from '../../../../config/config';
import { CrudSavePopupComponent } from '../../../_directives/crud-save-popup.component';
import { getOfferBuilderRoot } from '../../../steps-library/step-util';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  moduleId: module.id.toString(),
  selector: 'segment-conditions-popup',
  templateUrl: './segment-conditions-popup.component.html',
  styleUrls: ['./segment-conditions-popup.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('500ms ease-in', style({ opacity: 1 }))]),
    ]),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class SegmentConditionsPopupComponent extends CrudSavePopupComponent implements OnInit {
  isCampaignFilterLoading = false;
  funnelFulfillmentType = FunnelFulfillmentType;
  audience: Audience;
  availableCountries: { id: number | string; text: string }[] = [];
  AudienceConditionType = AudienceConditionType;
  AudienceBillingCycle = AudienceBillingCycle;
  AudienceFilterDescriptions = AudienceFilterDescriptions;
  billingOptions: number[] = AudienceBillingCycleOptions;
  filteredMaxBillingOptions: number[] = this.billingOptions;
  crms: CRM[];
  allCRMCampaigns: CRMCampaign[];
  selectedCRMCampaigns: {} = {};
  crmCampaigns: {} = {};
  isProductFiltersSelected: boolean = false;
  selectedCRMId = null;
  products: CampaignProduct[] = null;
  fulfillmentTypeSelected: FunnelFulfillmentType = null;
  selectedStates = [];
  selectedCountries = [];
  selectedCampaigns = [];
  showSortMenu = false;
  selectedFilter: ProductSortOption;
  audiencePopup = AudiencePopup;
  selectedProducts: CampaignProduct[] = [];
  availableStates: { id: number; text: string }[] = [];
  availableCampaigns: { id: number; text: string }[] = [];
  dropdownSettings = AudienceDropdownSettings;
  emptyBillingCycleValue = EmptyBillingCycleValue;
  surveyResponseCategories: SurveyResponseCategory[] = [];

  @Output() back: EventEmitter<void> = new EventEmitter();

  @ViewChildren(
    'SurveyResponseCategoriesRef, FulfillmentTypeRef, BillingCycleRef, TransactionFiltersRef, ' +
    'LocationRef, CampaignFiltersRef, ProductFiltersRef, TrafficSourceRef, ItemStatusRef'
  )
  conditionRefs!: QueryList<ElementRef>;

  showConditionError: { [key: string]: boolean } = {};

  creditCardTypes = AudienceCardTypeOptions.map((option) => ({ ...option, value: false }));
  paymentTypes = AudiencePaymentTypeOptions.map((option) => ({ ...option, value: false }));
  trafficSources = AudienceTrafficSourceOptions.map((option) => ({ ...option, value: false }));
  availableItemStatuses = AudienceItemStatusOptions;
  selectedItemStatuses = [];
  conditions: Record<AudienceConditionType, boolean> = {
    [AudienceConditionType.SurveyResponseCategories]: false,
    [AudienceConditionType.FulfillmentType]: false,
    [AudienceConditionType.BillingCycle]: false,
    [AudienceConditionType.TransactionFilters]: false,
    [AudienceConditionType.Location]: false,
    [AudienceConditionType.CampaignFilters]: false,
    [AudienceConditionType.ProductFilters]: false,
    [AudienceConditionType.TrafficSource]: false,
    [AudienceConditionType.ItemStatus]: false,
    [AudienceConditionType.UseProductFilters]: false,
    [AudienceConditionType.UseCampaignFilters]: false,
  };
  productSortOptionsList: { value: ProductSortOption; label: string }[] = [
    {
      value: ProductSortOption.ProductName,
      label: ProductSortOptionLabels[ProductSortOption.ProductName],
    },
    {
      value: ProductSortOption.ProductId,
      label: ProductSortOptionLabels[ProductSortOption.ProductId],
    },
  ];

  crmCampaignsMap: { [key: number]: any } = {};
  confirmingClear = false;
  productsModalInput: any[] = null;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected audienceService: AudienceService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected regionService: RegionService,
    protected crmService: CRMService,
    protected crmCampaignService: CRMCampaignService,
    protected campaignProductService: CampaignProductService,
    protected modalService: NgxSmartModalService,
    protected storageService: StorageService,
    protected loader: LoaderService,
    protected cancelReasonCategoriesService: CancelReasonCategoryService,
    protected singleStepFilterService: SingleStepFilterService
  ) {
    super(router, location, route, audienceService, alertService);
    this.isNew = true;
    this.objectName = 'segment';
  }

  ngOnInit() {
    this.form = this.formBuilder.group(
      {
        name: [null, Validators.required],
        use_product_filter: [false],
        is_3ds: [false],
        min_billing_cycle: [1, [Validators.required, Validators.min(1)]],
        max_billing_cycle: [null],
        use_billing_cycle: [false],
        merchant_ids: [null],
        crm_campaigns: [null],
        fulfillment_type: [null],
        states: [null],
        countries: [null],
        cc_types: [null],
        use_crm_campaign_filter: [false],
        reason_categories: [null],
        use_reason_filter: [false],
        traffic_sources: [null],
        aff_ids: [null],
        payment_types: [null],
        funnel_item_statuses: [null],
        parent_path: [null],
      },
      {
        validator: this.minLessThanMaxValidator('min_billing_cycle', 'max_billing_cycle'),
      }
    );

    super.ngOnInit();
    this.loading = true;

    if (this.isSingleStepMode) {
      // a filter audience is named by the backend, so the popup never asks for one
      this.form.get('name').clearValidators();
      this.form.get('name').updateValueAndValidity();
    } else {
      this.getSurveyResponseCategories();
    }

    this.getCountries();
    this.updateStates();

    // if audience_id is present (means edit flow), set conditions
    if (this.inputData.audience_id) {
      this.setConditions();
    } else {
      this.fetchCrmCampaigns();

      this.form.patchValue({
        name: this.inputData.name,
      });

      this.loading = false;
    }

    if (!this.isSingleStepMode) {
      this.form.patchValue({
        parent_path: this.inputData.offer_id,
      });
    }
  }

  /**
   * Single step mode edits a brand single step path's per-brand display filters rather than a
   * retention segment: the path is never entered from a survey, so the survey response categories
   * condition is hidden, and the filters can be cleared away entirely.
   */
  get isSingleStepMode(): boolean {
    return !!(this.inputData && this.inputData.funnel_id);
  }

  get canClearFilters(): boolean {
    return this.isSingleStepMode && !!this.inputData.filter_id;
  }

  fetchCrmCampaigns() {
    this.isCampaignFilterLoading = true;

    forkJoin([
      this.crmService.list({
        page: 1,
        page_size: config.maxPageSize,
        'type!': CRMTypeId.Test,
      }),
      this.crmCampaignService.list({
        page: 1,
        page_size: config.maxPageSize,
        'crm__type!': CRMTypeId.Test,
      }),
    ]).subscribe(
      (data: [Pager, Pager]) => {
        this.crms = data[0].results;

        this.allCRMCampaigns = data[1].results;
        this.buildCRMCampaignLists();
        this.isCampaignFilterLoading = false;
      },
      (error) => {
        this.isCampaignFilterLoading = false;
        this.handleError(error);
      }
    );
  }

  protected getFormData(): any {
    let merchantIds = null;
    let affIds = null;
    let states = null;
    let countries = null;
    let cardTypes = null;
    let paymentTypes = null;
    let trafficSources = [];
    let funnelItemStatuses = [];
    let crmCampaigns = [];
    let surveyResponseCategories = [];

    const useBillingCycle = Number(this.form.value.use_billing_cycle);

    if (!this.fulfillmentTypeValue) {
      this.form.value.fulfillment_type = null;
    }

    if (!useBillingCycle) {
      this.form.value.min_billing_cycle = DefaultMinBillingCycle;
      this.form.value.max_billing_cycle = null;
    }

    if (!(this.form.value.merchant_ids && this.form.value.merchant_ids.length)) {
      this.form.value.merchant_ids = null;
    }

    const selectedCreditCards = this.getSelectedTypes(this.creditCardTypes);
    const selectedPaymentTypes = this.getSelectedTypes(this.paymentTypes);
    const selectedTrafficSources = this.getSelectedTypes(this.trafficSources);
    const selectedSurveyResponseCategories = this.getSelectedTypes(this.surveyResponseCategories);

    if (selectedCreditCards.length) {
      cardTypes = selectedCreditCards;
    }

    if (selectedPaymentTypes.length) {
      paymentTypes = selectedPaymentTypes;
    }

    if (selectedTrafficSources.length) {
      trafficSources = selectedTrafficSources;
    }

    if (this.selectedItemStatuses.length) {
      this.selectedItemStatuses.forEach((status: { id: number; text: string }) => {
        funnelItemStatuses.push(status.id);
      });
    }

    if (selectedSurveyResponseCategories.length) {
      surveyResponseCategories = selectedSurveyResponseCategories;
      this.form.value.use_reason_filter = true;
    } else {
      this.form.value.use_reason_filter = false;
    }

    if (this.selectedStates.length) {
      states = [];
      this.form.value.states.forEach((state: { id: number; text: string }) => {
        states.push(state.id);
      });
    }

    if (this.selectedCountries && this.selectedCountries.length) {
      countries = [];
      this.form.value.countries.forEach((country: { id: number; text: string }) => {
        countries.push(country.id);
      });
    }

    if (this.selectedCampaigns.length) {
      this.selectedCampaigns.forEach((campaign: { id: number; text: string }) => {
        crmCampaigns.push(campaign.id);
      });
      this.form.value.use_crm_campaign_filter = true;
    } else {
      this.form.value.use_crm_campaign_filter = false;
      crmCampaigns = [];
    }

    if (this.products && this.products.length && this.isProductFiltersSelected) {
      this.form.value.use_product_filter = true;
    } else {
      this.form.value.use_product_filter = false;
    }

    if (this.form.value.merchant_ids && this.form.value.merchant_ids.length) {
      merchantIds = splitAudienceIds(this.form.value.merchant_ids);
    }

    if (this.form.value.aff_ids && this.form.value.aff_ids.length) {
      affIds = splitAudienceIds(this.form.value.aff_ids);
    }

    const filters = {
      merchant_ids: merchantIds,
      states: states,
      countries: countries,
      cc_types: cardTypes,
      traffic_sources: trafficSources,
      funnel_item_statuses: funnelItemStatuses,
      crm_campaigns: crmCampaigns,
      aff_ids: affIds,
      payment_types: paymentTypes,
      reason_categories: surveyResponseCategories,
    };

    const formData = Object.assign({}, this.form.value, filters);

    if (this.isSingleStepMode) {
      // a filter audience never segments a path, so parent_path is not part of its payload
      delete formData.parent_path;
    }

    return formData;
  }

  setConditions() {
    this.audienceService.get(this.inputData.audience_id).subscribe((audience: Audience) => {
      if (audience) {
        this.audience = audience;
        if (audience.fulfillment_type) {
          this.setFulfillmentConditions(audience.fulfillment_type);
        }

        if (audience.use_billing_cycle) {
          this.setBillingCycleConditions(audience.max_billing_cycle, audience.min_billing_cycle);
        }
        if (audience.countries && audience.countries.length) {
          this.setLocationConditions();
        }

        if (
          (audience.cc_types && audience.cc_types.length) ||
          (audience.payment_types && audience.payment_types.length) ||
          audience.is_3ds ||
          (audience.merchant_ids && audience.merchant_ids.length)
        ) {
          this.setTransactionConditions();
        }

        if (audience.traffic_sources && audience.traffic_sources.length) {
          this.setTrafficSourceConditions();
        }

        if (audience.funnel_item_statuses && audience.funnel_item_statuses.length) {
          this.setItemStatusConditions();
        }

        if (audience.use_product_filter) {
          this.isProductFiltersSelected = true;
          this.getProducts();
          this.conditions[AudienceConditionType.ProductFilters] = true;
        }

        if (audience.use_crm_campaign_filter) {
          this.conditions[AudienceConditionType.CampaignFilters] = true;
          this.isCampaignFilterLoading = true;
          this.setCampaignFilterConditions();
        } else {
          this.fetchCrmCampaigns();
        }

        if (audience.use_reason_filter && audience.reason_categories && audience.reason_categories.length) {
          this.conditions[AudienceConditionType.SurveyResponseCategories] = true;
          if (!this.surveyResponseCategories.length) {
            this.cancelReasonCategoriesService.list({page: 1, page_size: config.maxPageSize}).subscribe((response: Pager) => {
              this.surveyResponseCategories = response.results.map((reason: SurveyResponseCategory) => ({
                ...reason,
                value: false,
              }));
              this.convertToTypes(this.surveyResponseCategories, this.audience.reason_categories);
            });
          } else {
            this.convertToTypes(this.surveyResponseCategories, this.audience.reason_categories);
          }
        }

        this.form.patchValue(audience);
        this.id = this.audience.id;
        this.formId = this.audience.id.toString();
        this.isNew = false;
        this.loading = false;
      }
    });
  }

  onSubmit(): void {
    this.showConditionError = {};
    const invalidConditions: AudienceConditionType[] = [];

    for (const condition of Object.values(AudienceConditionType)) {
      const isActive = this.isConditionActive(condition);
      const hasValue = this.hasSelectedValue(condition);

      if (isActive && !hasValue) {
        this.showConditionError[condition] = true;
        invalidConditions.push(condition);
      }
    }

    if (invalidConditions.length) {
      this.scrollToCondition(invalidConditions[0]);
    } else if (this.isSingleStepMode && this.isNew) {
      this.createFilter();
    } else {
      super.onSubmit();
    }
  }

  /**
   * The first save in single step mode creates the filter row and its audience together, so a
   * failure can not leave an audience behind. After that the popup is editing that audience and the
   * base save handles it.
   */
  private createFilter(onCreated?: () => void): void {
    this.submitted = true;

    if (!this.form.valid) {
      return;
    }

    this.loading = true;

    this.singleStepFilterService.create(this.getFilterData()).subscribe(
      (filter: SingleStepPathFilter) => {
        this.audience = filter.audience;
        this.id = filter.audience.id;
        this.formId = this.id.toString();
        this.isNew = false;
        // the popup can stay open after this (adding product filters), and any later save updates
        // the audience directly - so carry the generated name into the form
        this.form.patchValue({ name: filter.audience.name });
        this.inputData.filter_id = filter.id;
        this.inputData.audience_id = filter.audience.id;
        this.loading = false;
        this.canDeactivateService.setFormDirty(false);

        if (onCreated) {
          onCreated();
        } else {
          this.onSaveComplete(filter);
        }
      },
      (error) => {
        this.handleSubmitError(error);
        this.loading = false;
      }
    );
  }

  private getFilterData(): any {
    // the backend generates the audience name
    const { name, ...audience } = this.getFormData();

    return {
      campaign: this.inputData.campaign_id,
      funnel: this.inputData.funnel_id,
      audience: audience,
    };
  }

  /**
   * Clearing drops the brand's filters for this path entirely - the row and its audience go away, so
   * every customer of the brand sees the path's button again.
   */
  clearFilters(): void {
    if (!this.confirmingClear) {
      this.confirmingClear = true;
      return;
    }

    this.loading = true;

    this.singleStepFilterService.delete(this.inputData.filter_id).subscribe(
      () => {
        this.confirmingClear = false;
        this.canDeactivateService.setFormDirty(false);
        this.onSaveComplete(null);
      },
      (error) => {
        this.confirmingClear = false;
        this.handleError(error);
        this.loading = false;
      }
    );
  }

  cancelClearFilters(): void {
    this.confirmingClear = false;
  }

  hasSelectedValue(condition: AudienceConditionType): boolean {
    let result = true;

    if (condition === AudienceConditionType.SurveyResponseCategories) {
      const selectedSurveyResponseCategories = this.getSelectedTypes(this.surveyResponseCategories);
      result = selectedSurveyResponseCategories.length > 0;
    } else if (condition === AudienceConditionType.FulfillmentType) {
      result = !!this.fulfillmentTypeValue;
    } else if (condition === AudienceConditionType.BillingCycle) {
      result = this.form.value.min_billing_cycle && this.form.value.min_billing_cycle >= 1;
    } else if (condition === AudienceConditionType.TransactionFilters) {
      const is3ds = this.isBooleanFieldChecked('is_3ds');
      result =
        is3ds ||
        this.getSelectedTypes(this.creditCardTypes).length > 0 ||
        this.getSelectedTypes(this.paymentTypes).length > 0 ||
        (!!this.form.value.merchant_ids && this.form.value.merchant_ids.trim().length > 0);
    } else if (condition === AudienceConditionType.Location) {
      result = this.selectedCountries.length > 0 && this.selectedStates.length > 0;
    } else if (condition === AudienceConditionType.CampaignFilters) {
      result = this.selectedCampaigns.length > 0;
    } else if (condition === AudienceConditionType.ProductFilters) {
      result = this.products && this.products.length > 0;
    } else if (condition === AudienceConditionType.TrafficSource) {
      result = this.getSelectedTypes(this.trafficSources).length > 0;
    } else if (condition === AudienceConditionType.ItemStatus) {
      result = this.selectedItemStatuses.length > 0;
    }

    return result;
  }

  scrollToCondition(condition: AudienceConditionType): void {
    const refClassMap: Partial<Record<AudienceConditionType, string>> = {
      [AudienceConditionType.SurveyResponseCategories]: 'survey-response-categories',
      [AudienceConditionType.FulfillmentType]: 'fulfillment-type',
      [AudienceConditionType.BillingCycle]: 'billing-cycle',
      [AudienceConditionType.TransactionFilters]: 'transaction-filters',
      [AudienceConditionType.Location]: 'location',
      [AudienceConditionType.CampaignFilters]: 'campaign-filters',
      [AudienceConditionType.ProductFilters]: 'product-filters',
      [AudienceConditionType.TrafficSource]: 'traffic-source',
      [AudienceConditionType.ItemStatus]: 'item-status',
    };

    let elementToScroll: HTMLElement | null = null;

    const refClass = refClassMap[condition];
    const refs = this.conditionRefs ? this.conditionRefs.toArray() : [];
    const foundRef = refs.find((ref) => (ref.nativeElement as HTMLElement).classList.contains(refClass));

    elementToScroll = foundRef ? (foundRef.nativeElement as HTMLElement) : null;

    if (elementToScroll) {
      const container = document.querySelector('.audience') as HTMLElement;
      if (container) {
        const offsetTop = elementToScroll.offsetTop - container.offsetTop - 80;
        container.scrollTo({ top: offsetTop, behavior: 'smooth' });
      } else {
        elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  onConditionValueChange(condition: AudienceConditionType): void {
    const hasValue = this.hasSelectedValue(condition);
    if (hasValue) {
      this.showConditionError[condition] = false;
    }
  }

  onCheckboxChange(item: any, conditionType: AudienceConditionType): void {
    item.value = !item.value;

    this.onConditionValueChange(conditionType);
  }

  on3DSChange(event: Event): void {
    this.toggleBooleanField(event, 'is_3ds');
    this.onConditionValueChange(AudienceConditionType.TransactionFilters);
  }

  protected updateForm() {}

  protected buildCRMCampaignLists() {
    if (this.crms && this.allCRMCampaigns) {
      const selectedCRMCampaigns = {};

      // initialize empty crm campaign arrays for each crm
      this.crms.forEach((crm: CRM) => {
        this.selectedCRMCampaigns[crm.id] = [];
        this.crmCampaigns[crm.id] = [];
      });

      if (this.crms.length === 1) {
        this.selectedCRMId = this.crms[0].id;
      }

      // build a map of the selected crm campaign ids for faster lookup
      if (this.audience && this.audience.crm_campaigns) {
        for (const campaign_id of this.audience.crm_campaigns) {
          selectedCRMCampaigns[campaign_id] = true;
        }
      }

      // fill in the list of crm campaigns for each crm
      this.allCRMCampaigns.forEach((campaign: CRMCampaign) => {
        if (campaign.id in selectedCRMCampaigns) {
          this.selectedCRMCampaigns[campaign.crm].push(campaign);
        }

        this.crmCampaigns[campaign.crm].push(campaign);
        this.crmCampaignsMap[campaign.id] = campaign;
      });

      const campaignsList = [];
      this.allCRMCampaigns.forEach((campaign: CRMCampaign) => {
        campaignsList.push({
          id: campaign.id,
          text: getCRMCampaignLabel(campaign),
        });
      });
      this.availableCampaigns = campaignsList;
    }
  }

  navigateBackToOffers() {
    const section = this.route.snapshot.data['section'];
    this.router.navigate([getOfferBuilderRoot(section)]);
  }

  getCountries() {
    this.regionService.getCountries().subscribe((countries) => {
      this.availableCountries = countries
        .filter(({ id }) => id === 'us' || id === 'ca')
        .map(({ id, name }) => ({ id, text: name }));
    });
  }

  getSurveyResponseCategories() {
    this.cancelReasonCategoriesService.list({page: 1, page_size: config.maxPageSize}).subscribe((response: Pager) => {
      this.surveyResponseCategories = response.results.map((reason: SurveyResponseCategory) => ({
        ...reason,
        value: false,
      }));
    });
  }

  updateStates() {
    this.availableStates = [];

    if (!this.selectedCountries.length && !(this.form.value.countries && this.form.value.countries.length)) {
      this.availableStates = [];
      this.selectedStates = [];
    } else {
      const stateRequests = this.selectedCountries.map((country) => this.regionService.list(country.id));

      forkJoin(stateRequests).subscribe((responses: Region[][]) => {
        const availableStates = [];

        responses.forEach((states) => {
          states.forEach((state: Region) => {
            availableStates.push({ id: state.id, text: state.name });
          });
        });

        this.availableStates = availableStates;
      });

      this.onConditionValueChange(AudienceConditionType.Location);
    }
  }

  isConditionSelected(): boolean {
    const formData = this.getFormData();

    return Object.entries(formData).some(([key, value]) => {
      if (key === 'max_billing_cycle' || key === 'name') {
        return false;
      }

      // Check if the value is not null, not false, and not an empty array
      if (value !== null && value !== false && (!Array.isArray(value) || value.length > 0)) {
        return true;
      }

      return false;
    });
  }

  clearTransactionFilters() {
    this.form.get('is_3ds').setValue(false);
    this.form.get('merchant_ids').setValue(null);
    this.creditCardTypes.forEach((type) => {
      type.value = false;
    });
    this.paymentTypes.forEach((type) => {
      type.value = false;
    });
  }

  clearTrafficSourceFilters() {
    this.trafficSources.forEach((type) => {
      type.value = false;
    });
  }

  clearItemStatusFilters() {
    this.selectedItemStatuses = [];
    this.form.get('funnel_item_statuses').setValue([]);
  }

  clearSurveyResponseCategories() {
    this.surveyResponseCategories.forEach((category: SurveyResponseCategory) => {
      category.value = false;
    });
  }

  onMinRangeChange() {
    let minCycle = Number(this.form.get('min_billing_cycle').value);
    let maxCycle = Number(this.form.get('max_billing_cycle').value);

    this.filteredMaxBillingOptions = this.billingOptions.filter((value) => value >= minCycle);

    if (minCycle === BillingCycleNoMax) {
      maxCycle = null;
    } else if (minCycle > maxCycle) {
      maxCycle = minCycle + 1;
    }

    this.form.patchValue({
      min_billing_cycle: minCycle,
      max_billing_cycle: maxCycle,
      use_billing_cycle: true,
    });

    this.form.get('max_billing_cycle').enable();

    this.onConditionValueChange(AudienceConditionType.BillingCycle);
    this.form.updateValueAndValidity();
  }

  private getSelectedTypes(types: any): number[] {
    const typesArray: number[] = [];

    types.forEach((type) => {
      if (type.value) {
        typesArray.push(type.id);
      }
    });

    return typesArray;
  }

  addProductFilters() {
    if (!this.audience) {
      // the products live on the audience, so it has to exist before they can be attached
      if (this.isSingleStepMode) {
        this.createFilter(() => this.openProductsDialog());
      } else {
        this.createAudienceForProducts();
      }
    } else {
      this.openProductsDialog();
    }
  }

  private openProductsDialog() {
    this.isProductFiltersSelected = true;
    this.getProducts();
    this.modalService.getModal('productsDialog').open();
  }

  private createAudienceForProducts() {
    this.submitted = true;

    if (this.form.valid) {
      this.loading = true;
      this.audienceService.create(this.getFormData()).subscribe(
        (data: Audience) => {
          if ('id' in data) {
            this.id = data['id'];
          }
          this.audience = data;

          this.loading = false;
          this.isNew = false;
          this.canDeactivateService.setFormDirty(false);
          this.openProductsDialog();
        },
        (error) => {
          this.handleSubmitError(error);
          this.loading = false;
        }
      );
    }
  }

  protected getProducts() {
    if (this.audience) {
      this.loading = true;

      this.campaignProductService
        .list({
          audiences: this.audience.id,
          page: 1,
          page_size: config.maxPageSize,
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (page: Pager) => {
            const productResults = page.results.length ? page.results : [];
            this.products = productResults.map((product) => {
              const matched =
                product.default_crm_campaign && this.crmCampaignsMap[product.default_crm_campaign]
                  ? this.crmCampaignsMap[product.default_crm_campaign]
                  : {};

              return {
                ...product,
                crm_campaign_id: matched.crm_campaign_id || null,
                crm_campaign_name: matched.name || null,
              };
            });

            this.onConditionValueChange(AudienceConditionType.ProductFilters);

            this.loading = false;
          },
          (error) => {
            this.loading = false;
            this.handleError(error);
          }
        );
    }
  }

  getProductImageUrl(product) {
    return getCampaignProductImageUrl(product, ImageSize.small);
  }

  removeProductsFromAudience(productIds: number[]) {
    this.loading = true;
    this.audienceService
      .remove_campaign_products(this.audience.id, {
        campaign_products: productIds,
      })
      .subscribe(
        (_) => {
          this.loading = false;
          this.getProducts();
        },
        (error) => {
          this.loading = false;
          this.handleError(error);
        }
      );
  }

  onProductsSelected(productIds: string[] | number[]) {
    this.modalService.getModal('productsDialog').close();
    this.addProductsToFunnel(productIds);
  }

  private populateCampaignProductRequests(productIds: string[] | number[]) {
    const requests = [];
    while (productIds.length > 0) {
      requests.push(
        this.audienceService.add_campaign_products(this.audience.id, {
          campaign_products: productIds.splice(0, AudienceProductBatchSize),
        })
      );
    }

    return requests;
  }

  addProductsToFunnel(productIds: string[] | number[]) {
    forkJoin(this.populateCampaignProductRequests(productIds)).subscribe(
      (_) => {
        this.loading = false;
        this.getProducts();
      },
      (error) => {
        this.loading = false;
        this.handleError(error);
      }
    );
  }

  publish() {
    const audienceId = this.id || this.audience.id;
    if (audienceId) {
      this.audienceService.publish(audienceId).subscribe(
        () => {
          this.loading = false;
          this.alertService.success('Audience Published Successfully.', true);
          this.navigate(['/audiences'], { replaceUrl: true });
        },
        (error) => {
          this.handleError(error);
          this.loading = false;
        }
      );
    }
  }

  protected onSaveComplete(data) {
    this.resetForm();
    this.loading = false;
    this.onSave.emit(data);
  }

  onBackClick(): void {
    if (this.inputData.popupType === AudiencePopup.Create) {
      this.back.emit();
    } else {
      this.onCancel.emit();
    }
  }

  minLessThanMaxValidator(minKey: string, maxKey: string): ValidatorFn {
    return (formGroup: FormGroup): ValidationErrors | null => {
      const minControl = formGroup.controls[minKey];
      const maxControl = formGroup.controls[maxKey];

      if (
        minControl.value != null &&
        maxControl.value != null &&
        minControl.value !== EmptyBillingCycleValue &&
        maxControl.value !== EmptyBillingCycleValue &&
        +minControl.value > +maxControl.value
      ) {
        return { minGreaterThanMax: true };
      }

      return null;
    };
  }

  applyFilter(value: ProductSortOption): void {
    let filteredData = [...this.products];
    this.selectedFilter = value;

    switch (this.selectedFilter) {
      case ProductSortOption.ProductName:
        filteredData.sort((a, b) => a.name.localeCompare(b.name));
        break;

      case ProductSortOption.ProductId:
        filteredData.sort((a, b) => Number(a.campaign_product_id) - Number(b.campaign_product_id));
        break;

      case ProductSortOption.CampaignName:
        filteredData.sort((a, b) => (a.crm_campaign_name || '').localeCompare(b.crm_campaign_name || ''));
        break;

      case ProductSortOption.CampaignId:
        filteredData.sort((a, b) => Number(a.crm_campaign_id) - Number(b.crm_campaign_id));
        break;

      case ProductSortOption.OfferId:
        filteredData.sort((a, b) => Number(a.offer_id || 0) - Number(b.offer_id || 0));
        break;
    }

    this.products = filteredData;
  }

  toggleSortMenu() {
    this.showSortMenu = !this.showSortMenu;
  }

  get selectedSortOption() {
    return ProductSortOptionLabels[this.selectedFilter];
  }

  closeSortMenu() {
    this.showSortMenu = false;
  }

  toggleCondition(conditionType: AudienceConditionType, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.conditions[conditionType] = true;

      if (conditionType === AudienceConditionType.ProductFilters) {
        this.isProductFiltersSelected = true;
        this.onConditionValueChange(conditionType);
      } else if (conditionType === AudienceConditionType.BillingCycle) {
        const useBillingCycle = this.form.get('use_billing_cycle').value;

        if (!useBillingCycle) {
          this.form.patchValue({
            min_billing_cycle: EmptyBillingCycleValue,
            max_billing_cycle: EmptyBillingCycleValue,
          });
          this.form.get('max_billing_cycle').disable();
        }

        this.onConditionValueChange(conditionType);
      }
    } else {
      this.conditions[conditionType] = false;

      // ✅ Clear validation error for this condition when toggle is OFF
      this.showConditionError[conditionType] = false;

      switch (conditionType) {
        case AudienceConditionType.SurveyResponseCategories:
          this.clearSurveyResponseCategories();
          break;

        case AudienceConditionType.FulfillmentType:
          this.fulfillmentTypeSelected = null;
          this.form.get('fulfillment_type').setValue(null);
          break;

        case AudienceConditionType.BillingCycle:
          this.form.patchValue({
            min_billing_cycle: DefaultMinBillingCycle,
            max_billing_cycle: null,
            use_billing_cycle: false,
          });
          break;

        case AudienceConditionType.TransactionFilters:
          this.clearTransactionFilters();
          break;

        case AudienceConditionType.Location:
          this.selectedStates = [];
          this.selectedCountries = [];
          this.form.get('countries').setValue([]);
          this.form.get('states').setValue([]);
          break;

        case AudienceConditionType.CampaignFilters:
          this.crms.forEach((crm: CRM) => {
            this.selectedCRMCampaigns[crm.id] = [];
          });
          this.selectedCampaigns = [];
          break;

        case AudienceConditionType.ProductFilters:
          this.isProductFiltersSelected = false;
          if (this.products.length) {
            this.loading = true;
            const productIds = this.products.map((product) => Number(product.id));
            this.removeProductsFromAudience(productIds);
            this.products = [];
          }
          break;

        case AudienceConditionType.TrafficSource:
          this.clearTrafficSourceFilters();
          break;

        case AudienceConditionType.ItemStatus:
          this.clearItemStatusFilters();
          break;

        default:
          break;
      }
    }
  }

  isConditionActive(conditionType: AudienceConditionType): boolean {
    return this.conditions[conditionType] === true;
  }

  setFulfillmentConditions(fulfillmentType: FunnelFulfillmentType) {
    this.form.patchValue({
      fulfillment_type: fulfillmentType,
    });

    this.conditions[AudienceConditionType.FulfillmentType] = true;
  }
  setBillingCycleConditions(maxBillingCycle: number, minBillingCycle: number) {
    this.form.patchValue({
      max_billing_cycle: maxBillingCycle,
      min_billing_cycle: minBillingCycle,
      use_billing_cycle: true,
    });

    this.conditions[AudienceConditionType.BillingCycle] = true;
  }

  setLocationConditions() {
    this.regionService.getCountries().subscribe((countries: Region[]) => {
      const countryLabels = {};
      const selectedCountries = [];

      countries.forEach((country: Region) => {
        countryLabels[country.id] = country.name;
      });

      this.audience.countries.forEach((value) => {
        const updatedValue = value.toLowerCase();
        if (countryLabels[updatedValue]) {
          selectedCountries.push({ id: updatedValue, text: countryLabels[updatedValue] });
        }
      });

      this.form.patchValue({ countries: selectedCountries });
      this.selectedCountries = selectedCountries;
    });

    this.updateStates();

    if (this.audience.states && this.audience.states.length) {
      const stateRequests = this.selectedCountries.map((country) => this.regionService.list(country.id));

      forkJoin(stateRequests).subscribe((responses: Region[][]) => {
        const stateLabels = {};
        const selectedStates = [];

        responses.forEach((states) => {
          states.forEach((state: Region) => {
            stateLabels[state.id] = state.name;
          });
        });

        this.audience.states.forEach((value) => {
          if (stateLabels[value]) {
            selectedStates.push({ id: value, text: stateLabels[value] });
          }
        });

        this.form.patchValue({ states: selectedStates });
        this.selectedStates = selectedStates;
      });
    }

    this.conditions[AudienceConditionType.Location] = true;
  }

  setCampaignFilterConditions() {
    forkJoin([
      this.crmService.list({
        page: 1,
        page_size: config.maxPageSize,
        'type!': CRMTypeId.Test,
      }),
      this.crmCampaignService.list({
        page: 1,
        page_size: config.maxPageSize,
        'crm__type!': CRMTypeId.Test,
      }),
    ]).subscribe(
      (data: [Pager, Pager]) => {
        this.crms = data[0].results;
        this.allCRMCampaigns = data[1].results;

        const campaignLabels = {};
        const selectedCampaigns = [];
        this.allCRMCampaigns.forEach((campaign: CRMCampaign) => {
          campaignLabels[campaign.id] = campaign.name;
        });

        this.audience.crm_campaigns.forEach((value) => {
          selectedCampaigns.push({ id: value, text: campaignLabels[value] });
        });

        this.form.patchValue({ crm_campaigns: selectedCampaigns });
        this.selectedCampaigns = selectedCampaigns;
        this.isCampaignFilterLoading = false;
      },
      (error) => {
        this.handleError(error);
        this.isCampaignFilterLoading = false;
      }
    );
  }

  setTransactionConditions() {
    const isMerchantId = this.audience.merchant_ids && this.audience.merchant_ids.length;
    const isCreditCardsSelected = this.audience.cc_types && this.audience.cc_types.length;
    const isPaymentTypeSelected = this.audience.payment_types && this.audience.payment_types.length;

    if (isMerchantId || isCreditCardsSelected || this.audience.is_3ds || isPaymentTypeSelected) {
      this.conditions[AudienceConditionType.TransactionFilters] = true;
    }

    if (this.audience.is_3ds) {
      this.form.patchValue({
        is_3ds: true,
      });
    }

    if (isMerchantId) {
      this.form.patchValue({
        merchant_ids: this.audience.merchant_ids.join(','),
      });
    }

    if (isCreditCardsSelected) {
      this.convertToTypes(this.creditCardTypes, this.audience.cc_types);
    }

    if (isPaymentTypeSelected) {
      this.convertToTypes(this.paymentTypes, this.audience.payment_types);
    }
  }

  setTrafficSourceConditions() {
    this.conditions[AudienceConditionType.TrafficSource] = true;
    this.convertToTypes(this.trafficSources, this.audience.traffic_sources);
  }

  setItemStatusConditions() {
    this.conditions[AudienceConditionType.ItemStatus] = true;

    const statusLabels = {};
    AudienceItemStatusOptions.forEach((option: { id: number; text: string }) => {
      statusLabels[option.id] = option.text;
    });

    const selectedItemStatuses = [];
    this.audience.funnel_item_statuses.forEach((value: number) => {
      if (statusLabels[value] !== undefined) {
        selectedItemStatuses.push({ id: value, text: statusLabels[value] });
      }
    });

    this.form.patchValue({ funnel_item_statuses: selectedItemStatuses });
    this.selectedItemStatuses = selectedItemStatuses;
  }

  private convertToTypes(types, selectedTypes: number[]) {
    // Loop through the array of numbers and set the corresponding properties to true
    let selectedTypesMap = {};
    selectedTypes.forEach((type) => {
      selectedTypesMap[type] = true;
    });

    types.forEach((type) => {
      type.value = type.id in selectedTypesMap;
    });
  }

  get fulfillmentTypeValue() {
    return this.form.get('fulfillment_type').value;
  }

  get isCancelOneTimeOrder(): boolean {
    return this.inputData && this.inputData.offer_intent === OfferIntents.CancelOrder;
  }

  popupTypeTextMap: Partial<Record<AudiencePopup, string>> = {
    [AudiencePopup.Create]: 'Next',
    [AudiencePopup.Update]: 'Save',
    [AudiencePopup.Conditions]: 'Save',
  };
}
